"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var usePrevious_1 = require("../usePrevious");
function isEqual(a, b) {
    return a === b;
}
exports.useChange = function (value, callback, comparator) {
    if (comparator === void 0) { comparator = isEqual; }
    var previous = usePrevious_1.usePrevious(value);
    React.useEffect(function () {
        if (typeof callback !== "function") {
            console.error("A non-function callback was passed to the useChange hook. callback must be a function.");
            throw new Error("A non-function callback was passed to the useChange hook. callback must be a function.");
        }
        if (typeof callback === "function") {
            if (!comparator(previous, value)) {
                callback(previous, value);
            }
        }
    }, [value, previous, comparator, callback]);
};
//# sourceMappingURL=index.js.map